// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"159":"component---src-pages-events-jsx","230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","351":"commons"}[chunkId] + "-" + {"159":"381cf72546d4dd66e1a3","230":"0a6b959324c9f6118eea","256":"a49c490a678036086f5b","351":"7bf2c69bda615822b789"}[chunkId] + ".js";
};